import { useEffect, useState } from 'react';

import { getBreakpoints } from '../../utils/viewport/getBreakpoints';

const getMatches = (query: string): boolean => {
  return window.matchMedia(query).matches;
};

export const MQ_MOBILE_NAV = `(max-width: ${
  getBreakpoints().mobileNavMinWidth
}px)`;

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(getMatches(query));

  useEffect(() => {
    function handleChange() {
      setMatches(getMatches(query));
    }
    handleChange();

    const matchMedia = window.matchMedia(query);

    if (matchMedia.addEventListener) {
      matchMedia.addEventListener('change', handleChange, { passive: true });
    } else {
      matchMedia.addListener(handleChange);
    }

    return () => {
      if (matchMedia.removeEventListener) {
        matchMedia.removeEventListener('change', handleChange);
      } else {
        matchMedia.removeListener(handleChange);
      }
    };
  }, [query]);

  return matches;
}
